<template lang="pug">
  nav#sidemenu.navbar
    nav.nav.flex-column.main
      #border
      a.title.nav-link(v-for="(section, index) in sections" :href="'#section'+ (index + 1)" @click="activeLink(index)")
        p.mt-0.pa-0(v-html="section.title")
        nav.nav.flex-column.sub
          a.sub.subtitle.smaller(:class="'s' + (index + 1) +'s' + (subindex + 1)" v-for="(subsection, subindex) in section.subsections") {{subsection.title}}
</template>

<script>
export default {
  name: "Menu",
  data() {
    return {
      sections: [
        {
          number: 1,
          title: "Antecedentes",
          slug: "antecedentes",
          showCollapse: false,
          subsections: [
            {
              number: 1,
              title: "Orígenes y Luchas, Movimientos Agraristas y Vidalismo",
              slug: "orígenes",
              active: false
            },
            {
              number: 2,
              title: "Fundación de El Quemado",
              slug: "fundación",
              active: false
            },
            {
              number: 3,
              title: "Insurgencia y Contrainsurgencia",
              slug: "insurgencia",
              active: false
            }
          ]
        },
        {
          number: 2,
          title: "Hechos<br> 1972 - 1976",
          slug: "hechos",
          showCollapse: false,
          subsections: [
            {
              number: 1,
              title: "Verano de 1972",
              slug: "verano",
              active: false
            },
            {
              number: 2,
              title: "Inicio de Hechos en El Quemado",
              slug: "inicio-hechos",
              active: false
            },
            {
              number: 3,
              title: "Extracción y Encarcelamiento",
              slug: "encarcelamiento",
              active: false
            },
            {
              number: 4,
              title: "Las Familias en El Quemado",
              slug: "familias",
              active: false
            },
            {
              number: 5,
              title: "La vida en la cárcel",
              slug: "vida-cárcel",
              active: false
            },
            {
              number: 6,
              title: "Liberación",
              slug: "liberación",
              active: false
            }
          ]
        },
        {
          number: 3,
          title: "Consecuencias 1976 a la fecha",
          slug: "consecuencias-1976",
          showCollapse: false,
          subsections: [
            {
              number: 1,
              title: "Consecuencias inmediatas",
              slug: "consecuencias",
              active: false
            },
            {
              number: 2,
              title: "1980s-2000s, EPR",
              slug: "epr",
              active: false
            },
            {
              number: 3,
              title: "FEMOSPP",
              slug: "femospp",
              active: false
            },
            {
              number: 4,
              title: "COMVERDAD",
              slug: "comverdad",
              active: false
            },
            {
              number: 5,
              title: "Revictimización",
              slug: "revictimización",
              active: false
            },
            {
              number: 5,
              title: "Cuarta fundación de El Quemado",
              slug: "cuarta-fundación",
              active: false
            },
            {
              number: 6,
              title: "Proceso de Reparación con CEAV",
              slug: "reparación",
              active: false
            }
          ]
        },
         {
          number: 4,
          title: "MVDF",
          slug: "mvdf",
          showCollapse: false,
          subsections: [
            {
              number: 1,
              title: "",
              slug: "",
              active: false
            }
          ]
        },
      ]
    }
  },
  methods: {
    activeLink(chosen) {
      const sections = document.querySelectorAll('.nav-link');
      sections.forEach((s, i) => {
        if (i == chosen) {
          s.classList.add('active')
          s.querySelectorAll('a.sub')[0].style.opacity = 1;
        }
        else {
          s.classList.remove('active');
          s.querySelectorAll('a.sub').forEach(child => {
            child.style.opacity = 0;
          })
        }
      });
    }
  }
}
</script>

<style lang="scss">
#sidemenu {
  z-index: 3;
  .main {
    list-style-type: none;
    position: relative;
    //border-left: 1px solid #fff;
    margin: 10px auto;
    //max-height: 77vh;
    #border {
      border-left: 1px solid #fff;
      position: absolute;
      top: 10px;
      left: -2px;
      bottom: 10px;
    }
    .title {
      color: rgb(101, 115, 111); 
      text-align: left;
      text-transform: uppercase;
      font-weight: 900;
      margin: 0;
      padding-top: 0;
      font-size: 0.8rem;
      line-height: 1.3;
      padding-left: 15px;
      &.active{
        color: #fff;
      }
      p {
        margin-bottom: 3px;
      }
    }
    .title:last-child {
      padding-bottom: 0 !important;
    }
    .subtitle {
      text-transform: none;
      color: #fff;
      opacity: 0;
      font-weight: 500;
      line-height: 1;
      margin-top: -0.67vh;
      &:first-of-type {
        margin-top: 1px;
      }
    }
  }
  .main > a {
    margin: 20px 0;
  }
  .main > a:before {
    content: ' ';
    background: #fff;
    display: inline-block;
    position: absolute;
    border-radius: 50%;
    border: 3px solid #fff;
    left: -6px;
    width: 10px;
    height: 10px;
    z-index: 400;
    margin-top: 4px;
  }
  .main > a.active:before {
    content: ' ';
    background: #9d2449;
    display: inline-block;
    position: absolute;
    border-radius: 50%;
    border: 2px solid #fff;
    left: -10px;
    width: 18px;
    height: 18px;
    z-index: 400;
  }
  .sub {
    position: relative;
    padding: 0;
  }
  .sub > a:before {
    content: ' ';
    background: rgb(153, 152, 81);
    display: inline-block;
    position: absolute;
    border-radius: 50%;
    border: 3px solid rgb(153, 152, 81);
    left: -21.5px;
    width: 10px;
    height: 10px;
    z-index: 400;
    margin-top: 2px;
  }
  .sub.s4s1 {
    opacity: 0 !important;
  }
}

</style>